module.exports = __webpack_public_path__ + "static/img/news-dtl-banner.6c94797.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news-dtl-banner.png
// module id = o5uK
// module chunks = 1